import { Utente } from './../../@core/models/utente';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { BASE_PATH_MOODLE, BASE_PATH_SERVER, pathJoin } from '@src/environments/configs';
import { map } from 'rxjs/operators';


export interface MoodleGroup {
    "id": number;
    "courseid": number;
    "name": string;
    "description": string;
    "descriptionformat": number;
    "enrolmentkey": string;
    "idnumber": string;
}

export interface MoodleCategory {
    "id": number;
    "name": string;
    "idnumber": string;
    "description": string;
    "descriptionformat": number;
    "parent": number;
    "sortorder": number;
    "coursecount": number;
    "visible": number;
    "visibleold": number;
    "timemodified": number;
    "depth": number;
    "path": string;
    "theme": string;

    "id_distretto": number,
    "id_macrozona": number,
    "id_azienda": number,

}

export interface MoodleCourseWrapper {
    "courseid": number;
    "roleid": number;
    "userid": number;
    "course": MoodleCourse;
    "groups": MoodleGroup[];
}

export interface MoodleCourse {

    "id": number;
    "shortname": string;
    "categoryid": number;
    "categorysortorder": number;
    "fullname": string;
    "displayname": string;
    "idnumber": string;
    "summary": string;
    "summaryformat": number;
    "format": string;
    "showgrades": number;
    "newsitems": number;
    "startdate": number;
    "enddate": number;
    "numsections": number;
    "maxbytes": number;
    "showreports": number;
    "visible": number;
    "groupmode": number;
    "groupmodeforce": number;
    "defaultgroupingid": number;
    "timecreated": number;
    "timemodified": number;
    "enablecompletion": number;
    "completionnotify": number;
    "lang": string;
    "forcetheme": string;
    "courseformatoptions": [
        {
            "name": string;
            "value": number
        }
    ]
}

export interface MoodleRole {
    "roleid": number;
    "name": string;
    "shortname": string;
    "sortorder": number;
}

export interface MoodleUser {
    "id": number;
    "username": string;
    "fullname": string;
    "groups": MoodleGroup[];
    "roles": MoodleRole[];
    "enrolledcourses": MoodleCourse[];
}


@Injectable({
    providedIn: 'root'
})
export class MoodleService {


    private baseUrl = BASE_PATH_SERVER;
    private getJSONHeader(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }

    constructor(
        private http: HttpClient,
        private router: Router,
    ) { }

    getCourses(): Observable<MoodleCourse[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses']);
        const headers = this.getJSONHeader();
        return this.http.get<{ courses: MoodleCourse[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.courses;
            },
            () => {
                console.error('errore, reset non riuscito');
            },
        ));
    }


    getCategoryCourses(id_category: number): Observable<MoodleCourse[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'categories', id_category.toString(), 'courses']);
        const headers = this.getJSONHeader();
        return this.http.get<{ courses: MoodleCourse[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.courses;
            },
            () => {
                console.error('errore, reset non riuscito');
            },
        ));
    }


    getCourseGroups(course_id: number): Observable<MoodleGroup[]> {

        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups']);
        const headers = this.getJSONHeader();
        return this.http.get<{ groups: MoodleGroup[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.groups;
            },
            () => {
                console.error('errore, reset non riuscito');
            },
        ));
    }

    getCategories(): Observable<MoodleCategory[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'categories']);
        const headers = this.getJSONHeader();
        return this.http.get<{ categorie: MoodleCategory[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.categorie;
            },
            () => {
                console.error('errore, reset non riuscito');
            },
        ));
    }

    deleteGroup(group_id: number, course_id: number): Observable<any> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'delete']);
        return this.http.post(url, {});
    }

    clearGroupUsers(group_id: number, course_id: number): Observable<any> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'clear']);
        return this.http.post(url, {});
    }


    createGroup(group_name: string, course_id: number): Observable<any> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups']);
        const body = {
            group_name: group_name
        }

        return this.http.put(url, body);
    }

    addAllUsersToGroup(course_id: number, group_id: number,
        filters: {} = {},
        limit: number = 0,
        offset: number = 0,
        orderby: string[] = null,
    ): Observable<any> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'add_users_list']);
        const dict_params = {};

        if (offset) {
            dict_params["offset"] = +offset;
        }
        if (limit) {
            dict_params["limit"] = +limit;
        }
        if (orderby) {
            dict_params["orderby"] = orderby;
        }

        const body = filters;
        return this.http
            .post(url, body, {
                params: new HttpParams({ fromObject: dict_params }),
                headers: this.getJSONHeader(),
            });
    }

    synchMoodleOperator(username: string) {
        const url = pathJoin([this.baseUrl, 'operatori', username, 'sync_moodle']);
        return this.http.post(url, {});
    }

    deleteOperator(username: string) {
        const url = pathJoin([this.baseUrl, 'operatori', username, 'delete']);
        return this.http.post(url, {});
    }

    synchMoodleUser(user_id: number): Observable<{ corsi: number[], utente: Utente, moodle_user: MoodleUser }> {
        const url = pathJoin([this.baseUrl, 'utenti', user_id.toString(), 'sync_moodle']);
        return this.http.post<{ corsi: number[], utente: Utente, moodle_user: MoodleUser }>(url, {});
    }


    addUserToGroup(user_moodle_id: number, course_id: number, group_id: number) {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'users', user_moodle_id.toString()]);
        return this.http.put(url, {});
    }

    removeUserFromGroup(user_moodle_id: number, course_id: number, group_id: number) {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'users', user_moodle_id.toString()]);
        return this.http.delete(url, {});
    }

    listGroupUsers(course_id: number, group_id: number): Observable<MoodleUser[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'courses', course_id.toString(), 'groups', group_id.toString(), 'users']);
        const headers = this.getJSONHeader();
        return this.http.get<{ members: MoodleUser[] }>(url, { headers: headers })
            .pipe(map(
                response => {
                    // console.info(url, response);
                    return response.members;
                },
                () => {
                    console.error('errore, reset non riuscito');
                },
            ));
    }

    openMoodleUser(moodle_id: number, admin = false) {
        if (!moodle_id) {
            return;
        }
        let url = this.getMoodleUserLink(moodle_id, admin);
        window.open(url, '_blank', 'noreferrer');
    }

    openMoodleGroup(group_id: number, admin = false) {
        if (!group_id) {
            return;
        }
        let url = this.getMoodleGroupLink(group_id, admin);
        window.open(url, '_blank', 'noreferrer');
    }

    openMoodleCourse(course_id: number, admin = false) {
        if (!course_id) {
            return;
        }
        let url = this.getMoodleCourseLink(course_id, admin);
        window.open(url, '_blank', 'noreferrer');
    }

    openMoodleCategory(course_id: number, admin = false) {
        if (!course_id) {
            return;
        }
        let url = this.getMoodleCategoryLink(course_id, admin);
        window.open(url, '_blank', 'noreferrer');
    }


    getMoodleUserLink(moodle_id: number, admin = false) {
        // https://happymoodle.netfarm.it/user/profile.php?id=83
        return BASE_PATH_MOODLE + '/user/profile.php?id=' + moodle_id;
    }

    getMoodleCategoryLink(moodle_id: number, admin = false) {
        if (admin) {
            // https://happymoodle.netfarm.it/course/management.php?categoryid=47
            return BASE_PATH_MOODLE + '/course/management.php?categoryid=' + moodle_id;
        } else {
            // https://happymoodle.netfarm.it/course/index.php?categoryid=47
            return BASE_PATH_MOODLE + '/course/index.php?categoryid=' + moodle_id;
        }
    }

    getMoodleCourseLink(moodle_id: number, admin = false) {
        if (admin) {
            // https://happymoodle.netfarm.it/course/management.php?courseid=47
            return BASE_PATH_MOODLE + '/course/management.php?courseid=' + moodle_id;
        } else {
            // https://happymoodle.netfarm.it/course/view.php?id=14
            return BASE_PATH_MOODLE + '/course/view.php?id=' + moodle_id;
        }
    }

    getMoodleGroupLink(group_id: number, admin = false) {
        if (admin) {
            return BASE_PATH_MOODLE + '/course/management.php?groupid=' + group_id;
        } else {
            // https://happymoodle.netfarm.it/course/view.php?id=14
            return BASE_PATH_MOODLE + '/group/view.php?id=' + group_id;
        }
    }



    getUserCourses(user_id: string): Observable<MoodleCourseWrapper[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'users', user_id, 'courses']);
        const headers = this.getJSONHeader();
        return this.http.get<{ courses: MoodleCourseWrapper[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.courses;
            },
            () => {
                console.error('errore, chiamata non riuscita');
            },
        ));
    }


    getUserCourseGroups(user_id: string, course_id): Observable<MoodleGroup[]> {
        const url = pathJoin([this.baseUrl, 'moodle', 'users', user_id, 'courses', course_id.toString(), 'groups']);
        const headers = this.getJSONHeader();
        return this.http.get<{ groups: MoodleGroup[] }>(url, { headers: headers }).pipe(map(
            response => {
                // console.info(url, response);
                return response.groups;
            },
            () => {
                console.error('errore, chiamata non riuscita');
            },
        ));
    }
}
